var kosan = kosan || {};

kosan.co2calculator = new function () {
    var self = this;

    this.init = function () {
        var co2Element = document.querySelector("#co2calculator");
        if(co2Element) {
            new Vue({
                el: co2Element,
                data: {
                    inputText: null,
                    saving: null,
                    totalSavings: null,
                    buttonValue: null,
                    calculatedButtonValue: null
                },
                mounted: function () {
                    var getButtonValue = document.querySelectorAll('.btn');
                    for (var i = 0; i < getButtonValue.length; i++) {
                        var item = getButtonValue[i]
                        item.addEventListener('click', function (event) {
                            var att = event.currentTarget.getAttribute('data-target');
                            console.log(att);
                        })
                    }
                },
                methods: {
                    calculate20: function () {
                        //SVG gauges script
                        var firstGauge = document.querySelector('.container .progress');
                        var getDataTarget = document.querySelector('.js-button20');
                        var firstTarget = parseInt(getDataTarget.getAttribute('data-target'));
                        var firstGaugeReadout = document.querySelector('.container .percentage > .value');
    
                        //variables
                        var gaugeR = parseInt(document.querySelectorAll('circle')[0].getAttribute('r'));
                        var gaugeC = gaugeR * Math.PI * 2;
                        var animationDuration = 1.5;
    
                        //varibles for calculating savings
                        var getInput = document.querySelector('.input-value');
                        var getInputValue = getInput.value;
                        var calculateSaving = getInputValue * 3.3 * 0.19;
                        var totalSaving = Math.round(calculateSaving * 10) / 10;
    
                        this.buttonValue = firstTarget;
                        this.calculatedButtonValue = getInputValue / 5;
    
                        //init svg circles
                        var circles = document.querySelectorAll('circle');
                        var gauges = document.querySelectorAll('.progress');
                        TweenMax.set(circles, {
                            strokeDashoffset: gaugeC
                        });
    
                        TweenMax.set(gauges, {
                            attr: {
                                'stroke-dasharray': gaugeC + ' ' + gaugeC
                            }
                        });
    
                        //calculate the offset
                        function calculateOffset(t, c) {
                            var target = c - (c * t) / 100;
                            return target;
                        }
    
                        //timeline
                        var tl = new TimelineMax();
    
                        //first gauge animation
                        tl.to(firstGauge, animationDuration, {
                            strokeDashoffset: calculateOffset(firstTarget, gaugeC),
                            ease: Bounce.easeOut,
                            onUpdate: function () {
                                if (getInputValue) {
                                    firstGaugeReadout.textContent = totalSaving;
                                }
                            }
                        });
    
                        var el = document.querySelector(".value")
                        od = new Odometer({
                            el: el,
                            duration: 1000
                        });
                    },
                    calculate30: function () {
                        //SVG gauges script
                        var firstGauge = document.querySelector('.container .progress');
                        var getDataTarget = document.querySelector('.js-button30');
                        var firstTarget = parseInt(getDataTarget.getAttribute('data-target'));
                        var firstGaugeReadout = document.querySelector('.container .percentage > .value');
    
                        //variables
                        var gaugeR = parseInt(document.querySelectorAll('circle')[0].getAttribute('r'));
                        var gaugeC = gaugeR * Math.PI * 2;
                        var animationDuration = 1.5;
    
                        //varibles for calculating savings
                        var getInput = document.querySelector('.input-value');
                        var getInputValue = getInput.value;
                        var calculateSaving = getInputValue * 3.3 * 0.285;
                        var totalSaving = Math.round(calculateSaving * 10) / 10;
    
                        this.buttonValue = firstTarget;
                        var roundNumber = getInputValue / 3.33;
                        this.calculatedButtonValue = Math.round(roundNumber * 10) / 10;
    
                        //init svg circles
                        var circles = document.querySelectorAll('circle');
                        var gauges = document.querySelectorAll('.progress');
                        TweenMax.set(circles, {
                            strokeDashoffset: gaugeC
                        });
    
                        TweenMax.set(gauges, {
                            attr: {
                                'stroke-dasharray': gaugeC + ' ' + gaugeC
                            }
                        });
    
                        //calculate the offset
                        function calculateOffset(t, c) {
                            var target = c - (c * t) / 100;
                            return target;
                        }
    
                        //timeline
                        var tl = new TimelineMax();
    
                        //first gauge animation
                        tl.to(firstGauge, animationDuration, {
                            strokeDashoffset: calculateOffset(firstTarget, gaugeC),
                            ease: Bounce.easeOut,
                            onUpdate: function () {
                                if (getInputValue) {
                                    firstGaugeReadout.textContent = totalSaving;
                                }
                            }
                        });
    
                        var el = document.querySelector(".value")
                        od = new Odometer({
                            el: el,
                            duration: 1000
                        });
                    },
                    calculate100: function () {
                        //SVG gauges script
                        var firstGauge = document.querySelector('.container .progress');
                        var getDataTarget = document.querySelector('.js-button100');
                        var firstTarget = parseInt(getDataTarget.getAttribute('data-target'));
                        var firstGaugeReadout = document.querySelector('.container .percentage > .value');
    
                        //variables
                        var gaugeR = parseInt(document.querySelectorAll('circle')[0].getAttribute('r'));
                        var gaugeC = gaugeR * Math.PI * 2;
                        var animationDuration = 1.5;
    
                        //varibles for calculating savings
                        var getInput = document.querySelector('.input-value');
                        var getInputValue = getInput.value;
                        var calculateSaving = getInputValue * 3.3 * 0.95;
                        var totalSaving = Math.round(calculateSaving * 10) / 10;
    
                        this.buttonValue = firstTarget;
                        this.calculatedButtonValue = getInputValue;
    
                        //init svg circles
                        var circles = document.querySelectorAll('circle');
                        var gauges = document.querySelectorAll('.progress');
                        TweenMax.set(circles, {
                            strokeDashoffset: gaugeC
                        });
    
                        TweenMax.set(gauges, {
                            attr: {
                                'stroke-dasharray': gaugeC + ' ' + gaugeC
                            }
                        });
    
                        //calculate the offset
                        function calculateOffset(t, c) {
                            var target = c - (c * t) / 100;
                            return target;
                        }
    
                        //timeline
                        var tl = new TimelineMax();
    
                        //first gauge animation
                        tl.to(firstGauge, animationDuration, {
                            strokeDashoffset: calculateOffset(firstTarget, gaugeC),
                            ease: Bounce.easeOut,
                            onUpdate: function () {
                                if (getInputValue) {
                                    firstGaugeReadout.textContent = totalSaving;
                                }
                            }
                        });
    
                        var el = document.querySelector(".value")
                        od = new Odometer({
                            el: el,
                            duration: 1000
                        });
                    }
                }
            })
        }
    };
}